<template>
  <BModal size="md" body-class="p-5 rounded-lg" :visible="visible" hide-header hide-footer @hide="$emit('close', true)">
    <div class="text-center">
      <img
        style="width: 160px"
        class="d-block mx-auto mb-4"
        :src="industry == 'cannabis' ? '/img/logos/apex-logo.png' : '/img/logos/bushel-logo.png'"
        :alt="industry == 'cannabis' ? 'Apex Logo' : 'Bushel44 Logo'"
      />
      <div class="shadow border rounded bg-white p-5 mb-3">
        <h3 class="font-weight-bold gradient-text">While you are waiting for approval...</h3>
        <p class="font-weight-bold text-dark mb-1">You can still shop the marketplace!</p>
        <p class="text-dark mb-1">
          If you would like to shop this vendor or others in the state you can do so by clicking the button below and you will be redirected to the
          marketplace.
        </p>
        <BushelBtn class="my-3 px-4 py-2" variant="success" @click="() => goToApp()"> Go to marketplace </BushelBtn>
      </div>
      <BushelBtn class="btn-sm" outline variant="primary" @click="$emit('close', true)"> Close </BushelBtn>
    </div>
  </BModal>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["close"],
  data() {
    return {
      industry: "cannabis",
      appUrl: APP_URL,
    };
  },
  methods: {
    goToApp() {
      window.location.href = this.appUrl;
    },
  },
};
</script>
<style>
.gradient-text {
  background: linear-gradient(to right, var(--success), var(--primary) 60%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
